// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".d2418f98e180ccbd1425c30b9af6f5d6.js";
};